<template>
  <div class="section-l">
    <navigation tabindex="0" />
    <div style="height: 80px; width: 100%"></div>
    <div class="user">
      <div class="user-c">
        <h2>登录</h2>
        <div class="userinput" style="margin-top: 0px">
          <input
            type="text"
            placeholder="请输入用户名"
            v-model="userName"
            ref="userName"
            @blur="userNameBlur"
            @input="changeName"
          />
        </div>
        <div class="userinput userinputpsd">
          <input
            type="password"
            placeholder="请输入密码，密码长度8~18位"
            v-model="pwd"
            ref="pwd"
            @blur="pwdBlur"
          />
        </div>
        <div class="agreement">
          <div
            v-show="agreement == 1"
            @click="agreementFn(0)"
            style="width: 15px; height: 15px; float: left; cursor: pointer"
          >
            <img
              src="../../static/login/i7.png"
              alt=""
              style="display: block; width: 100%; height: 100%"
            />
          </div>
          <div
            v-show="agreement == 0"
            @click="agreementFn(1)"
            style="width: 15px; height: 15px; float: left; cursor: pointer"
          >
            <img
              src="../../static/login/i6.png"
              alt=""
              style="display: block; width: 100%; height: 100%"
            />
          </div>
          <span>记住密码</span>
          <span
            style="color: #3476c1"
            @click="$router.push({ name: 'forgetpwd' })"
            >忘记密码？</span
          >
        </div>
        <div class="go" @click="goFn()">登录</div>
        <div class="gologin" style="font-family: MicrosoftYaHei;">
          还没有账号？<span
            style="color: #3476c1;font-family: MicrosoftYaHei;"
            @click="$router.push({ name: 'register' })"
            >去注册一个吧！</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import areasData from "@/assets/areas.json";
import { isEmailVue } from "@/utils/validate";
import jwtDecode from "jwt-decode";
import md5 from "js-md5";
import navigation from "../../components/common/navigation.vue";
export default {
  name: "login",
  components: {
    navigation,
  },
  data() {
    return {
      isShow: false, //手机号提示信息
      isConfirm: false, //密码确认
      isChecked: true,
      radio: "1", //单选按钮
      agreement: 0,
      userNameCheck: true,
      pwdCheck: true,
      errortext: "",
      token: "",
      userName: "",
      pwd: "",
    };
  },

  methods: {
    goIndex() {
      sessionStorage.setItem("tabIndex", "1");
      this.$router.push({ name: "home" });
    },
    agreementFn(s) {
      this.agreement = s;
    },
    changeName() {
      // let s = this.$refs.userName.value;
      // console.log(33,s);
    },
    userNameBlur() {
      let s = this.$refs.userName.value;
      // console.log(3333,s);
    },
    pwdBlur() {
      if (this.$refs.pwd.value != "") {
        if (!/^[a-zA-Z0-9_]{6,18}$/.test(this.$refs.pwd.value)) {
          this.pwdCheck = false;
          this.errortext = "密码长度只能在8-18位之间";
        } else {
          this.pwdCheck = true;
          this.errortext = "";
        }
      }
    },
    goFn() {
      let userName = this.$refs.userName.value;
      let pwd = this.$refs.pwd.value;
      let obj = {
        id: userName,
        pwd,
      };
      if (this.agreement == 1) {
        localStorage.setItem("tokenRemember", JSON.stringify(obj));
      } else {
        localStorage.removeItem("tokenRemember");
      }
      if (userName && pwd && this.userNameCheck && this.pwdCheck) {
        let param = {
          name: this.$refs.userName.value,
          // pwd:md5(this.$refs.pwd.value),
          pwd: this.$refs.pwd.value,
          flag: this.agreement,
        };
        this.$axios
          .post("/v1/cloud/common/user/login", param)
          .then(({ data }) => {
            // if(data.code == 200){
            if (data) {
              let token = data.token;
              this.token = token;
              if (token) {
                localStorage.setItem("token", token);
                // localStorage.setItem('headImg',data.data.headImg);
                // localStorage.setItem('mobile',data.data.mobile);
                localStorage.setItem("completeStatus", data.loginUser.role); //是否完善信息 0是未完善 大于0是完善
                // localStorage.setItem('completeStatus',0);  //是否完善信息 0是未完善
                localStorage.setItem("account", data.loginUser.account); //用户名
                this.$emit('loginStatus', 'asdasdasd')
                // localStorage.setItem('userId',data.data.id); //用户id

                if (data.loginUser.role > 0) {
                  sessionStorage.setItem("tabIndex", "1");
                  this.$router.push({ name: "home" });
                } else {
                  sessionStorage.setItem("tabIndex", "0");
                  this.$router.push({ name: "me" });
                }
                // sessionStorage.setItem('tabIndex',1);
                // this.$router.push({name:'home'})
              }
            }
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.message,
              type: "error",
            });
          });
      }
    },
  },
  created() {
    var _this = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.goFn();
      }
    };
  },
  mounted() {
    if (localStorage.tokenRemember) {
      let remember = JSON.parse(localStorage.tokenRemember);
      if (remember) {
        this.userName = remember.id;
        this.pwd = remember.pwd;
        this.agreement = 1;
      }
    }
  },
};
</script>

<style scoped lang="less">
a {
  text-decoration: none;
}
li {
  list-style: none;
}
input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.section-l {
  width: 100%;
  background: #fafafa;
  .user {
    width: 100%;
    background: #f3f3f3;
    height: 760px;
    overflow: hidden;
    background-image: url("../../static/common/backgroundimg.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    padding-top: 76px;
    box-sizing: border-box;
    .user-c {
      width: 450px;
      height: 388px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      margin: 0 auto;
      padding: 0 40px;
      box-sizing: border-box;
      input::placeholder {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 40px;
      }
      h2 {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        line-height: 94px;
      }
      .userinput {
        width: 100%;
        height: 40px;
        border: 1px solid #eeeeee;
        border-radius: 3px;
        padding-left: 36px;
        box-sizing: border-box;
        background-image: url("../../static/common/usericon.png");
        background-size: 18px 18px;
        background-position: 10px 12px;
        background-repeat: no-repeat;
        img {
          display: block;
          float: left;
          width: 18px;
          height: 18px;
          margin-left: 16px;
          margin-top: 8px;
          margin-right: 12px;
        }
        input {
          width: 100%;
          height: 100%;
          font-size: 15px;
          // color:#bfbfbf;
        }
        span {
          display: block;
          float: right;
          height: 36px;
          line-height: 36px;
          padding-right: 8px;
          color: #bfbfbf;
        }
      }
      .userinputpsd {
        margin-top: 30px;
        background-image: url("../../static/common/psdicon.png");
        background-position: 10px 11px;
      }
      .go {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #3476c1;
        border-radius: 4px;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-top: 10px;
      }
      .captcha {
        overflow: hidden;
        width: 100%;
        height: 36px;
        line-height: 36px;
        margin-top: 7px;
        .getcode {
          float: right;
          width: 126px;
          height: 36px;
          background: #29cc8a;
          text-align: center;
          color: white;
          cursor: pointer;
        }
      }
      .gologin {
        margin-top: 20px;
        font-size: 12px;
        height: 12px;
        line-height: 12px;
        color: #999999;
        span {
          cursor: pointer;
          color: #3476C1;
        }
      }
      .errortext {
        width: 100%;
        height: 15px;
        line-height: 15px;
        margin: 8px 0px;
        color: #df0000;
      }
      .agreement {
        height: 15px;
        line-height: 15px;
        margin-top: 13px;
        width: 100%;
        font-size: 15px;
        span:nth-of-type(1) {
          display: block;
          float: left;
          margin-left: 10px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
        span:nth-of-type(2) {
          display: block;
          float: right;
          cursor: pointer;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #3476c1;
        }
      }
    }
  }
}
</style>